import React, { Component } from 'react';
import { hot } from 'react-hot-loader'
import {Route, Switch} from "react-router";
import Login from "./security/login";
import Master from "./Master/Master";

class App extends Component {

  componentDidMount() {
  }

  render() {
    return (
        <React.Fragment>
          <Switch>
              <Route path="/login" render={() => <Login/>}/>
            <Route path="/" render={() => <Master />}/>

          </Switch>
        </React.Fragment>
    );
  }
}

export default hot(module)(App);
